import { authServiceApi } from "../../app/authServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { AUTH_LOCALSTORAGE_NAME } from "../../constants/constants";
import {
  GetEmployeeResponseType,
  SigninDataType,
  SigninResponsiveType,
  SignupDataType,
  SignupResponseType,
} from "../../types";
import { userLoggedIn } from "./authSlice";

export const authApi = authServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    signin: builder.mutation<SigninResponsiveType, SigninDataType>({
      query: (data) => ({
        url: API_URL.signin,
        method: "POST",
        body: data,
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;

          const userData = {
            access_token: data?.data?.token,
            user: data?.data,
            role: "SUPER_ADMIN",
          };

          localStorage.setItem(
            AUTH_LOCALSTORAGE_NAME,
            JSON.stringify(userData),
          );

          dispatch(userLoggedIn(userData));
        } catch (err) {}
      },
    }),
    signup: builder.mutation<SignupResponseType, SignupDataType>({
      query: (data) => ({
        url: API_URL.signup,
        method: "POST",
        body: data,
      }),
    }),
    updatePassword: builder.mutation<unknown, unknown>({
      query: (data) => ({
        url: API_URL.updatePassword,
        method: "PUT",
        body: data,
      }),
    }),

    getMe: builder.query<GetEmployeeResponseType, unknown>({
      query: (id) => ({
        url: `${API_URL.getMe}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetAllEmployeesDetails" }],
    }),
    loginWithToken: builder.mutation<SigninResponsiveType, any>({
      query: (data) => ({
        url: API_URL.loginWithToken,
        method: "POST",
        body: data,
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;

          const userData = {
            access_token: data?.data?.token,
            user: data?.data,
            role: data?.data?.role,
          };

          localStorage.setItem(
            AUTH_LOCALSTORAGE_NAME,
            JSON.stringify(userData),
          );

          dispatch(userLoggedIn(userData));
        } catch (err) {}
      },
    }),
  }),
});

export const {
  useSigninMutation,
  useSignupMutation,
  useUpdatePasswordMutation,
  useGetMeQuery,
  useLoginWithTokenMutation,
} = authApi;
